export default (status: number) => {
  return status >= 200 && status < 300;
};